<template>
  <div class="sidebar">
    <vue-custom-scrollbar id="book_viewer__cats" class="scroll-area scroll-area__cats scroll-area__cats__exercise" :settings="settingsViewBookSidebar">
      <div class="book-viewer__cats__info exercise__cats__exam__info book-viewer__cats__wrap">
        <div class="item">
          <div class="item__title">Tên đề: </div>
          <div class="item__value">{{ dataSource.name }}</div>
        </div>
        <div class="item">
          <div class="item__title">Môn: </div>
          <div class="item__value">{{ dataSource.subjectName }}</div>
        </div>
        <div class="item">
          <div class="item__title">Lớp: </div>
          <div class="item__value">{{ dataSource.className }}</div>
        </div>
        <div class="item">
          <div class="item__title">Số câu: </div>
          <div class="item__value">{{ dataSource.numberQuestion ? dataSource.numberQuestion : 0 }}</div>
        </div>
        <div class="item">
          <div class="item__title">Thời gian làm bài: </div>
          <div class="item__value">{{ dataSource.timeToDo ? dataSource.timeToDo : 0 }} phút</div>
        </div>
        <div class="item">
          <div class="item__title">Tình trạng: </div>
          <div class="item__value">{{ checkTypeExam(dataSource.isWork) }}</div>
        </div>
        <div class="item">
          <div class="item__title">Điểm số: </div>
          <div class="item__value">{{ dataSource.score ? dataSource.score.toFixed(1) : '...' }}</div>
        </div>
        <div class="item">
          <div class="item__title">Số câu đúng: </div>
          <div class="item__value">{{ dataSource.totalCorrectAnswers ? dataSource.totalCorrectAnswers : '...' }}</div>
        </div>
        <div class="item">
          <div class="item__title">Số câu sai: </div>
          <div class="item__value">{{ dataSource.totalInCorrectAnswers ? dataSource.totalInCorrectAnswers : '...' }}</div>
        </div>
      </div>
    </vue-custom-scrollbar>
  </div>
</template>

<script>
  import vueCustomScrollbar from 'vue-custom-scrollbar'
  import mixinExam from './../../_store/mixinExam'

  export default {
    name: 'ExamSidebar',
    mixins: [ mixinExam ],
    props: {
      dataSource: Object
    },
    components: {
      vueCustomScrollbar
    },
    data () {
      return {
        settingsViewBookSidebar: {
          maxScrollbarLength: 300
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  .book-viewer__cats__title {
    margin-bottom: 25px;
  }
  .item {
    @extend .display-flex;
    margin-bottom: 15px;

    &__title {
      width: 45%;
      margin-right: 1%;
      @extend .secondary-color-txt;
      @extend .font-size-15;
      @extend .font-sanpro-semibold;
    }

    &__value {
      width: 54%;
      @extend .font-size-16;
      @extend .font-sanpro-light;
      @extend .primary-color-txt;
    }
  }
</style>